// src/pages/DevenirPartenaire.jsx
import React from "react";
import { Link } from "react-router-dom";

import NavBar from "../components/layout/NavBar";
import Footer from "../components/layout/Footer";

import PourquoiPactePartenaires from "../sections/PourquoiPactePartenaires";
import CommentCaMarchePartenaires from "../sections/CommentCaMarchePartenaires";
import FAQPartenaires from "../sections/FAQPartenaire";
import AvisTroisPartenaires from "../sections/AvisCarouselPartenaire"
import Comparatif from "../sections/Comparatif"

import bgHero from "../images/partenaires.png";
import homescreentest from "../images/tel-commerce.png";
import LogoMain from "../images/main-logo.png";


export default function DevenirPartenaire() {
  return (
    <div className="relative min-h-screen text-black overflow-hidden bg-white">
      <NavBar />
      <section className="mx-auto max-w-[1519px] px-4 sm:px-6 lg:px-8 mt-6">
        <div className="relative overflow rounded-3xl shadow-lg">
          <div
            aria-hidden
            className="absolute inset-0 rounded-3xl bg-gradient-to-t from-[#E35EA7] to-[#FFDDEA]"
          />
          <div
            aria-hidden
            className="absolute inset-0 rounded-3xl bg-center bg-cover opacity-60"
            style={{ backgroundImage: `url(${bgHero})` }}
          />
          <div aria-hidden className="absolute inset-0 rounded-3xl bg-black/10" />

          <div
            className="
              relative grid grid-cols-1
              md:grid-cols-[30%_70%]
              items-center gap-6 lg:gap-10
              p-5 sm:p-8 lg:p-12
              min-h-[620px] lg:min-h-[840px]
            "
          >
            <div className="order-2 md:order-1 relative flex flex-col items-center md:items-start justify-start">
              <img
                src={homescreentest}
                alt="Aperçu application PACTE"
                className="
                  relative z-10
                  w-[78%] max-w-[380px]
                  sm:w-[90%] sm:max-w-[420px]
                  md:w-[140%] md:max-w-[660px]
                  md:-mt-12 md:-ml-48
                  mx-auto md:mx-0
                  drop-shadow-2xl
                "
              />
            </div>

            <div className="order-1 md:order-2 flex flex-col justify-center text-white md:pl-6">
              <h1 className="text-3xl sm:text-5xl font-asap font-semibold leading-tight max-w-[980px]">
                Devenez partenaire de l'association PACTE et dynamisez votre commerce local.
              </h1>

              <p className="mt-4 text-white/90 text-sm sm:text-base max-w-[760px]">
                Plus de visibilité auprès des habitants de Claix, des offres simples à
                publier, une fidélité intégrée et des événements communs. On vous
                accompagne pour une mise en place simple et rapide.
              </p>

              <div className="mt-6 flex flex-wrap items-center gap-4">
                <Link
                  to="/contact?type=partenaire"
                  className="inline-flex items-center justify-center rounded-full bg-black text-white
                             px-6 py-3 text-sm font-medium shadow-[0_10px_24px_rgba(0,0,0,0.35)]
                             hover:opacity-90 transition"
                >
                  Rejoindre le réseau
                </Link>
                <a
                  href="#comment"
                  className="inline-flex items-center justify-center rounded-full bg-white text-neutral-900
                             px-6 py-3 text-sm font-medium ring-1 ring-black/10 hover:bg-white/95 transition"
                >
                  Comment ça marche ?
                </a>
              </div>
            </div>
          </div>

          {/* Liseré interne */}
          <div aria-hidden className="pointer-events-none absolute inset-0 rounded-3xl ring-1 ring-white/30" />
        </div>
      </section>

    
      <PourquoiPactePartenaires />

      <section className="relative mx-auto max-w-[1519px] px-4 sm:px-6 lg:px-8 py-8 sm:py-10">
        <div className="overflow-hidden rounded-3xl">
          <div className="grid grid-cols-2 sm:grid-cols-4 text-center py-8">
            <div>
              <div className="text-3xl font-semibold text-black">+10</div>
              <div className="text-sm text-black/70 mt-1">commerçants</div>
            </div>
            <div>
              <div className="text-3xl font-semibold text-black">+244</div>
              <div className="text-sm text-black/70 mt-1">téléchargements</div>
            </div>
            <div>
              <div className="text-3xl font-semibold text-black">100%</div>
              <div className="text-sm text-black/70 mt-1">pensé local</div>
            </div>
            <div>
              <div className="text-3xl font-semibold text-black">Gratuit</div>
              <div className="text-sm text-black/70 mt-1">pour tous</div>
            </div>
          </div>
        </div>
      </section>

      <section id="comment" className="scroll-mt-24">
        <CommentCaMarchePartenaires/>
      </section>
      <AvisTroisPartenaires />
      <Comparatif />
      <FAQPartenaires />
      <Footer />
    </div>
  );
}

